import { ImagePreviewStatus } from 'components/ImagePreview';

export enum DotMedScanStepsEnum {
  dotMed = 0,
  dotMedPreview = 1,
  dotMedQuestions = 2,
  endOfTheFlow = 3,
}

export interface DotMedScanState {
  step: DotMedScanStepsEnum;
  imageStatus?: ImagePreviewStatus;
  imageUploadProgress?: number;
  imageErrorMessage?: string;
  imageErrorLabel?: string;
  dotMedImage?: string;
  imagePreview?: string;
  focusQuality?: number;
  focusQualityThreshold?: number;
  isBlankImage?: boolean;
  isWhiteImage?: boolean;
  file?: File;
}

export enum DotMedScanActionTypes {
  NEXT_STEP,
  PREVIOUS_STEP,
  SET_IMAGE_STATUS,
  SET_IMAGE_UPLOAD_PROGRESS,
}

interface DotMedScanActionPayload {
  type: DotMedScanActionTypes;
  payload: any;
}

export const initialState: DotMedScanState = {
  step: DotMedScanStepsEnum.dotMed,
};

export function nextStepAction(
  mainImageData?: {
    mainImage: string;
    focusQuality: number;
    focusQualityThreshold: number;
    file?: File;
    isBlankImage?: boolean;
    isWhiteImage?: boolean;
  },
  previewImage?: string
) {
  return {
    type: DotMedScanActionTypes.NEXT_STEP,
    payload: {
      mainImage: mainImageData?.mainImage,
      previewImage,
      focusQuality: mainImageData?.focusQuality,
      focusQualityThreshold: mainImageData?.focusQualityThreshold,
      file: mainImageData?.file,
      isBlankImage: mainImageData?.isBlankImage,
      isWhiteImage: mainImageData?.isWhiteImage,
    },
  };
}

export function previousStepAction() {
  return {
    type: DotMedScanActionTypes.PREVIOUS_STEP,
    payload: null,
  };
}

export function setImageStatusAction(
  imageStatus: ImagePreviewStatus,
  imageErrorMessage?: string,
  imageErrorLabel?: string
) {
  return {
    type: DotMedScanActionTypes.SET_IMAGE_STATUS,
    payload: { imageStatus, imageErrorMessage, imageErrorLabel },
  };
}

export function setImageUloadProgressAction(imageUploadProgress: number) {
  return {
    type: DotMedScanActionTypes.SET_IMAGE_UPLOAD_PROGRESS,
    payload: imageUploadProgress,
  };
}

export function reducer(
  state: DotMedScanState,
  action: DotMedScanActionPayload
): DotMedScanState {
  switch (action.type) {
    case DotMedScanActionTypes.NEXT_STEP:
      switch (state.step) {
        case DotMedScanStepsEnum.dotMed:
          return goToDotMedPreviewStep(state, action);

        case DotMedScanStepsEnum.dotMedPreview:
          return goToDotMedQuestionsFlow(state);

        case DotMedScanStepsEnum.dotMedQuestions:
          return goToEndOfTheFlow(state);

        default:
          return state;
      }

    case DotMedScanActionTypes.PREVIOUS_STEP:
      return {
        ...state,
        step: (state.step - 1) as DotMedScanStepsEnum,
        imageStatus: undefined,
        imageErrorMessage: undefined,
        dotMedImage: undefined,
        imagePreview: undefined,
      };

    case DotMedScanActionTypes.SET_IMAGE_STATUS:
      return {
        ...state,
        imageStatus: action.payload.imageStatus,
        imageErrorMessage: action.payload.imageErrorMessage,
        imageErrorLabel: action.payload.imageErrorLabel,
      };

    case DotMedScanActionTypes.SET_IMAGE_UPLOAD_PROGRESS:
      return {
        ...state,
        imageUploadProgress: action.payload,
      };

    default:
      return state;
  }
}

function goToDotMedPreviewStep(
  state: DotMedScanState,
  action: DotMedScanActionPayload
): DotMedScanState {
  return {
    ...state,
    step: DotMedScanStepsEnum.dotMedPreview,
    dotMedImage: action.payload.mainImage,
    imagePreview: action.payload.previewImage,
    imageStatus: ImagePreviewStatus.UPLOADING,
    imageErrorMessage: undefined,
    focusQuality: action.payload.focusQuality,
    focusQualityThreshold: action.payload.focusQualityThreshold,
    file: action.payload.file,
  };
}

function goToDotMedQuestionsFlow(state: DotMedScanState): DotMedScanState {
  return {
    ...state,
    step: DotMedScanStepsEnum.dotMedQuestions,
  };
}

function goToEndOfTheFlow(state: DotMedScanState): DotMedScanState {
  return {
    ...state,
    step: DotMedScanStepsEnum.endOfTheFlow,
  };
}
